import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type ReviewFile = {
  review_file_id?: number; // 리뷰 파일 idx
  review_id?: number; // 리뷰 idx
  file_name?: string; // 파일명
  file_url?: string; // 파일 URL
  type?: string; // 타입
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] ReviewFile
   * --
   */
  getReviewFiles: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_REVIEW_FILE, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] ReviewFile
   * --
   */
  getReviewFile: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_REVIEW_FILE, {
        review_file_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] ReviewFile
   * --
   */
  createReviewFile: async (body: ReviewFile) => {
    try {
      const res = await $http.post(APIConstant.CREATE_REVIEW_FILE, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] ReviewFile
   * --
   */
  updateReviewFile: async (body: ReviewFile) => {
    try {
      const { review_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_REVIEW_FILE, {
        review_id: review_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] ReviewFile
   * --
   */
  deleteReviewFile: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_REVIEW_FILE, {
        review_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] ReviewFile
   * --
   */
  bulkCreateReviewFile: async (body: ReviewFile[]) => {
    try {
      const res = await $http.post(APIConstant.BULK_CREATE_REVIEW_FILE, body);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
